exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map[data-v-69522f76] {\n  width: 100%;\n  height: 300px;\n  box-shadow: 0 1px 2px #dde4e7;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  overflow: hidden;\n}\n", ""]);

// exports
